import { css } from '@emotion/react';
import { styled } from '@mui/material';

import { RouterLink } from '@/components/router/RouterLink';
import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';

export const StyledLink = styled(RouterLink)(
  ({ theme }) => css`
    font-size: ${theme.typography.body1.fontSize};
    color: inherit;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      color: ${theme.palette.primary.main};
    }

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      font-size: ${theme.typography.body1.fontSize};
    }
  `,
) as typeof RouterLink;
